"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificazioneEmailApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class CertificazioneEmailApi extends runtime.BaseAPI {
    /**
     * Informazioni sulla certificazione email con tutti i dettagli relativi (Auth roles: Admin)
     */
    apiCertificazioneEmailIdCertificazioneEmailDettaglioGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idCertificazioneEmail === null || requestParameters.idCertificazioneEmail === undefined) {
                throw new runtime.RequiredError('idCertificazioneEmail', 'Required parameter requestParameters.idCertificazioneEmail was null or undefined when calling apiCertificazioneEmailIdCertificazioneEmailDettaglioGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/CertificazioneEmail/{idCertificazioneEmail}/dettaglio`.replace(`{${"idCertificazioneEmail"}}`, encodeURIComponent(String(requestParameters.idCertificazioneEmail))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.DettaglioCertificazioneEmailDtoFromJSON(jsonValue));
        });
    }
    /**
     * Informazioni sulla certificazione email con tutti i dettagli relativi (Auth roles: Admin)
     */
    apiCertificazioneEmailIdCertificazioneEmailDettaglioGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazioneEmailIdCertificazioneEmailDettaglioGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Invia Email con certificazione email inserita o inviata (Auth roles: Admin)
     */
    apiCertificazioneEmailIdCertificazioneEmailInviaEmailGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idCertificazioneEmail === null || requestParameters.idCertificazioneEmail === undefined) {
                throw new runtime.RequiredError('idCertificazioneEmail', 'Required parameter requestParameters.idCertificazioneEmail was null or undefined when calling apiCertificazioneEmailIdCertificazioneEmailInviaEmailGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/CertificazioneEmail/{idCertificazioneEmail}/invia-email`.replace(`{${"idCertificazioneEmail"}}`, encodeURIComponent(String(requestParameters.idCertificazioneEmail))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CertificazioneEmailDtoFromJSON(jsonValue));
        });
    }
    /**
     * Invia Email con certificazione email inserita o inviata (Auth roles: Admin)
     */
    apiCertificazioneEmailIdCertificazioneEmailInviaEmailGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazioneEmailIdCertificazioneEmailInviaEmailGetRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.CertificazioneEmailApi = CertificazioneEmailApi;
